// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-turnstile-field',
    mixins: [host.mixins.form],
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
});
// #endregion
